/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
// import _ from "lodash";
import React, { FC } from 'react';
import shortid from 'shortid';
import SectionWrapper from '../components/SectionWrapper';
import WidgetMapping from './Mapping';
import { IWidgetPropsGraphQL } from './widgetTypes';

const WidgetsGraphQL: FC<IWidgetPropsGraphQL> = ({ widget, customCss = false }) => {
  const componentPromises = widget?.items?.map(widget => {
    let widgetName = widget?.__typename;
    if (widgetName === 'HeroBlade') {
      widgetName = 'HeroBladeGraphQL';
    }
    const View = WidgetMapping[widgetName];

    if (!View) return <div key={shortid.generate()} />;
    const properties = (widget as any)?.commonProperties;
    return (
      <SectionWrapper
        key={shortid.generate()}
        hasBodyMargin={false}
        backgroundColor={properties?.backgroundColor}
        parentBackgroundColor={properties?.parentBackgroundColor}
        backgroundImage={properties?.backgroundImage}
        hasImageBlur={!!properties?.backgroundImage}
        isDark={!!properties?.isDark}
      >
        {customCss ? (
          <View key={shortid.generate()} {...widget} customCss />
        ) : (
          <View key={shortid.generate()} {...widget} />
        )}
      </SectionWrapper>
    );
  });
  return <>{componentPromises} </>;
};

export default WidgetsGraphQL;
